export function extractLocalizedString(localizedString, locale) {
    var keys = Object.keys(localizedString);
    if (keys.length === 0) {
        return '';
    }
    else if (locale) {
        return localizedString[locale];
    }
    else if (keys.length === 1) {
        return localizedString[keys[0]];
    }
    else {
        throw new Error("Number of locales on " + JSON.stringify(localizedString) + " is " + keys.length);
    }
}
var _t;
export function getCachedTranslationFunction(t) {
    if (!_t) {
        _t = t;
    }
    return _t;
}
//# sourceMappingURL=i18nLogic.js.map